import type { ReactNode } from 'react';
import type { DashboardDetail } from '../dashboardTypes';
import { DASH } from '../format';
import { NotesPanel } from './NotesPanel';

function Unavailable({ label }: { label: string }) {
  return <span title={`${label}: not available yet`}>{DASH}<span className="tpd-visually-hidden"> {label} not available yet</span></span>;
}

function Item({ label, children }: { label: string; children: ReactNode }) {
  return <div className="tpd-grid__item"><dt>{label}</dt><dd>{children}</dd></div>;
}

/**
 * Approval and Ownership tab (Figma S11, S25, S35, S41). The payroll processor, its assignment and reassignment, the initiator and Auto Tax Payment have no source
 * yet (BACKEND GAP), so they are a dash. Assign / Change Processor and Contact Client are not drawn: no endpoint exists for either. Internal notes are real.
 */
export function OwnershipTab({ detail, onSaved, onDraftChange }: { detail: DashboardDetail; onSaved: (updated: DashboardDetail) => void; onDraftChange: (hasDraft: boolean) => void }) {
  const { row } = detail;
  return (
    <div className="tpd-tabbody" data-testid="tab-ownership">
      <dl className="tpd-grid">
        <Item label="Payroll Processor"><Unavailable label="Payroll Processor" /></Item>
        <Item label="Assigned By"><Unavailable label="Assigned By" /></Item>
        <Item label="Assigned Date & Time"><Unavailable label="Assigned Date and Time" /></Item>
        <Item label="Last Reassigned By"><Unavailable label="Last Reassigned By" /></Item>
        <Item label="Payment Initiated By"><Unavailable label="Payment Initiated By" /></Item>
        <Item label="Initiation"><Unavailable label="Initiation" /></Item>
        <Item label="Payment Partner">{row.paymentPartner ?? <Unavailable label="Payment Partner" />}</Item>
        <Item label="Auto Tax Payment"><Unavailable label="Auto Tax Payment" /></Item>
      </dl>
      <NotesPanel paymentId={row.id} notes={detail.notes} onSaved={onSaved} onDraftChange={onDraftChange} />
    </div>
  );
}
